import './_styles.scss';

interface ListItemWithIconProps {
    icon?: string;
    label: string;
}

const ListItemWithIcon = ({ icon, label }: ListItemWithIconProps) => (
    <p className='ListItemWithIcon'>
        {icon && <span className={`${icon} ListItemWithIcon__icon`} />}
        {label}
    </p>
);

export default ListItemWithIcon;
